export type UIRequest = {
  method: string
  path: string
  page: string
}

export type FormField = {
  name: string
  value: string
}

export type UIForm = {
  fields: FormField[]
}

export type UIState = {
  url: string
  requests: UIRequest[]
  forms: UIForm[]
}

function setsEqual(a: string[], b: string[]): boolean {
  const aSet = new Set(a)
  const bSet = new Set(b)
  return aSet.size === bSet.size && [...aSet].every((item) => bSet.has(item))
}

function fields(form: UIForm): string[] {
  return form.fields.map((field) => `${field.name}: ${field.value}`)
}

function requests(requests: UIRequest[]): string[] {
  return requests.map((r) => `${r.method} ${r.path} ${r.page}`)
}

export function changedSince(
  previous: UIState,
  next: UIState,
): UIState | undefined {
  const forms = next.forms.filter((form, index) => {
    const before = previous.forms[index]
    return !before || !setsEqual(fields(form), fields(before))
  })

  const settled =
    next.url === previous.url &&
    next.forms.length === previous.forms.length &&
    setsEqual(requests(next.requests), requests(previous.requests)) &&
    forms.length === 0

  return settled ? undefined : { ...next, forms }
}
